module.exports = __webpack_public_path__ + "img/intelligent03.586018cd.png";